<script>
  export default {
    name: 'ImageModal',
    props: ['url', 'url2', 'text'],
    data() {
      return {
        isModalVisible: false,
        //nextURL: "",
        //signURL: "",
        //acceptURL: "",
      }
    },
    methods: {
      closeYes() {
        this.$emit('close');
      },
      closeNo() {
        this.$emit('close');
      }
    },
  };
</script>

<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="color:black;text-align:center;">
          <slot name="body">
            <h2 style="text-decoration: underline;">{{text}}</h2>
            <img id="pricing" class="pricing-img" :src="url">
            </br>
            <img id="pricing" class="pricing-img" :src="url2">
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>


